import { CSSObject, Theme } from '@mui/material';
import { skodaAgThemeParams } from './agGridSkodaTheme';
import { agGridCssIcons } from './agGridIcons';

/** agGrid CSS Variables */
export const agGridVariables = (theme: Theme): CSSObject => {
  const agTheme = skodaAgThemeParams(theme);

  return {
    '--ag-font-family': `${agTheme.fontFamily}`,
    '--ag-foreground-color': `${agTheme.foregroundColor}`,
    '--ag-header-foreground-color': `${agTheme.headerForegroundColor}`,
    '--ag-background-color': `${agTheme.backgroundColor}`,
    '--ag-header-background-color': `${agTheme.headerBackgroundColor}`,
    '--ag-subheader-background-color': `${agTheme.subHeaderBackgroundColor}`,
    '--ag-subheader-toolbar-background-color': `${agTheme.subHeaderToolbarBackgroundColor}`,
    '--ag-disabled-foreground-color': `${agTheme.disabledForegroundColor}`,
    '--ag-row-hover-color': `${agTheme.rowHoverColor}`,
    '--ag-checkbox-checked-color': `${agTheme.checkboxCheckedColor}`,
    '--ag-checkbox-indeterminate-color': `${agTheme.checkboxIndeterminateColor}`,
    '--ag-header-height': `${agTheme.headerHeight}px`,
    '--ag-header-column-resize-handle-color': `${agTheme.headerColumnResizeHandleColor}`,
    '--ag-selected-row-background-color': `${agTheme.selectedRowBackgroundColor}`,
    '--ag-cell-vertical-padding': `${agTheme.cellVerticalPadding}px`,
    '--ag-row-height': `${agTheme.rowHeight}px`,
    '--ag-pagination-panel-height': `${agTheme.paginationPanelHeight}px`,
    '--ag-font-size': `${agTheme.fontSize}px`,
    '--ag-header-font-size': `${agTheme.headerFontSize}px`,
    '--ag-header-font-weight': `'${agTheme.headerFontWeight}'`,
    '--ag-icon-size': `${agTheme.iconSize}px`,
    ...agGridCssIcons,
  };
};
